<div class="row">
    <!-- Header MRP report -->
    <div class="col-md-12">
        <h3 class="page-header-title"> <span>{{"MRP" | translate}}</span> / {{"MRP Report" | translate}}</h3>
    </div>
    <!-- End Header  MRP report -->
</div>